module.exports = __webpack_public_path__ + "img/pic_15.b13a2e28.jpg";